import request from '@/utils/request2'
// import request2 from '@/utils/request'

export function updateLivePhone(data) {
  return request({
    url: '/cloud/edata-sale/clue/livePhone/update',
    method: 'POST',
    data
  })
}

export function getSmsAreaCodes(params) {
  return request({
    url: '/cloud/edata-message/sms-area-code-do/sms/groupBySmsAreaCodes',
    method: 'GET',
    params
  })
}

export function getMailSuffixes(params) {
  return request({
    url: '/cloud/edata-message/mailSuffixes/query',
    method: 'GET',
    params
  })
}

export function saveTableColumns(data) {
  return request({
    url: '/cloud/edata-sale/sale/list/display/setting/save',
    method: 'POST',
    data
  })
}

export function getTableColumns(data) {
  return request({
    url: '/cloud/edata-sale/sale/list/display/setting/query',
    method: 'POST',
    data
  })
}
// 获取动态配置的H5网址
export function getDynamicH5Url(params) {
  return request({
    url: '/cloud/edata-user/domain-info/getDomainUrl',
    method: 'GET',
    params
  })
}

// 新增线索查询视图
export function viewAdd(data) {
  return request({
    url: `/cloud/edata-sale/clue/query/view/add`,
    method: 'POST',
    data
  })
}

// 删除线索查询视图
export function viewDelete(data) {
  return request({
    url: `/cloud/edata-sale/clue/query/view/delete?id=${data.id}`,
    method: 'POST'
  })
}

// 分页查询线索查询视图
export function getViewPage(data) {
  return request({
    url: `/cloud/edata-sale/clue/query/view/page`,
    method: 'POST',
    data
  })
}
